var productsMap = new Map();
// variable para determinar si el usuario esta en desktop o mobile
var isMobile = window.innerWidth < 1024 ? true : false;

$.fn.isInViewport = function () {
  var elementTop = $(this).offset().top;
  var elementBottom = elementTop + $(this).outerHeight();

  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();

  return elementBottom > viewportTop && elementTop < viewportBottom;
};

jQuery_T4NT(document).ready(function ($) {

  window.dl_objects_index = 0;
  /**
  *  Variant selection changed
  *  data-variant-toggle="{{ variant.id }}"
  */
  $(document).on("variant:changed", function (evt) {
    // console.log( evt.currentVariant );
    // $('[data-variant-toggle]').hide(0);
    // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
  });
  // $(document).pjax('.t4s-custom-pjax',  '#MainContent');
  //Filter product
  $(document).pjax(
    '.t4s-custom-pjax'
    , '.t4s-section-main-product',
    {
      container: '.t4s-section-main-product',
      fragment: '.t4s-section-main-product',
      timeout: 5000,
      scrollTo: false
    });
  $(document).on('pjax:end', function (xhr, textStatus, options) {
    T4SThemeSP._initProducts();
    T4SThemeSP.initCarousel();
  });
  $("body").on("click", ".t4-variant-custom", function () {
    const _this = $(this);
    const product = _this.data("product");
    const wrapper = _this.closest(".t4s-product");

    console.log(product);

    $(wrapper).find(".t4-variant-custom").removeClass("is-swatch--selected");
    _this.addClass("is-swatch--selected");

    $(wrapper).find(".t4s-product-main-img").attr("data-srcset", product.featured_image);
    $(wrapper).find(".t4s-product-hover-img").attr("data-srcset", product.images[1]);
    $(wrapper).find(".t4s-product-title a").attr("href", _this.data("url")).text(product.title);
    $(wrapper).find(".t4s-pr-addtocart").attr("data-variant-id", product.variants[0].id).attr("data-id", product.id).attr("href", _this.data("url"));
    $(wrapper).find(".t4s-pr-quickview").attr("data-id", product.id).attr("href", _this.data("url"));
    if (product.price_varies) {
      $(wrapper)
        .find(".t4s-product-price")
        .html(_this.data("price-min") + "-" + _this.data("price-max"));
    } else {
      if (product.price < product.compare_at_price) {
        $(wrapper).find(".t4s-product-price").html(`<del>${_this.data("compare-price")}</del><ins>${_this.data("price")}</ins>`);
        $(wrapper).find(".t4s-badge-sale").show();
        let discount = Math.round(((product.compare_at_price - product.price) * 100 / product.compare_at_price));
        //console.log(discount);
        $(wrapper).find(".t4s-badge-sale").html(`-${discount}%`);
      } else {
        $(wrapper).find(".t4s-product-price").html(_this.data("price"));
        $(wrapper).find(".t4s-badge-sale").hide();
      }

    }
    //console.log(product);
  });


  console.log("...")
  $('.t4s-navigation').hover(function () {
    $('html').addClass('is-header--stuck');
  }, function () {
    //$('html').removeClass('is-header--stuck');
    if (!$('.t4s-section-header').is(':hover')) {
      $('html').removeClass('is-header--stuck');
    }
  });


  // DATA LAYER IMPLEMENTATION
  console.log("datalayer objects");

  console.log(window.dl_objects);

  //click data-atc-form attribute
  $(document).on('click', '[data-atc-form]', function () {
    /*console.log("Add to cart");

    //get parent element with [data-dl-object="item_view"] attribute
    let parent = $(this).closest('[data-dl-object="item_view"]');
    let dl_object_id = parent.attr('data-dl-object-id');
    let dl_object_extra = parent.attr('data-dl-extra');

    console.log('Add to cart item with id: ' + dl_object_id);
    analizeProduct(dl_object_id, "", 'add_to_cart', dl_object_extra);
    */
  });

  // $(document).on('click', '[data-action-wishlist]', function () {
  //     console.log("Add to wishlist");
  // });

  $(document).on('click', '.t4s-site-nav__cart a', function () {

    let entry = {
      event: 'header_interaction',
      user_id: window.user_id,
      category: 'header',
      option: 'bolsa de compras'
    };

    dataLayer.push(entry);
  });

  $(document).on('click', '.t4s-site-nav__account a', function () {

    let entry = {
      event: 'header_interaction',
      user_id: window.user_id,
      category: 'header',
      option: 'Mi perfil'
    };

    dataLayer.push(entry);
  });

  $(document).on('click', '.t4s-site-nav__search a', function () {

  });

  $(document).on('click', '.t4s-site-nav__heart a', function () {

    let entry = {
      event: 'header_interaction',
      user_id: window.user_id,
      category: 'header',
      option: 'Lista de deseos'
    };

    dataLayer.push(entry);

  });

  $(document).on('click', '#showHelpButton', function () {

    let entry = {
      event: 'header_interaction',
      user_id: window.user_id,
      category: 'header',
      option: 'contactanos'
    };

    dataLayer.push(entry);

  });

  //subscribe to enter event from search input .t4s-search-header__input
  $(document).on('keypress', '.t4s-search-header__input', function (e) {
    if (e.which == 13) {

      let searchTerm = $(this).val();

      let entry = {
        event: 'buscar_click_enter',
        user_id: window.user_id,
        category: 'enter',
        option: searchTerm
      };

      dataLayer.push(entry);
    }
  });

  //subscribe to click event from search button .t4s-search-header__submit
  $(document).on('click', '.t4s-search-header__submit', function () {

    let searchTerm = $(".t4s-search-header__input").val();

    let entry = {
      event: 'buscar_click_enter',
      user_id: window.user_id,
      category: 'click',
      option: searchTerm
    };

    dataLayer.push(entry);
  });

  //subscribe to enter event from search input .t4s-mini-search__input
  $(document).on('keypress', '.t4s-mini-search__input', function (e) {
    if (e.which == 13) {

      let searchTerm = $(this).val();

      let entry = {
        event: 'buscar_click_enter',
        user_id: window.user_id,
        category: 'enter',
        option: searchTerm
      };

      dataLayer.push(entry);
    }
  });

  //subscribe to click event from search button .t4s-mini-search__submit
  $(document).on('click', '.t4s-mini-search__submit', function () {

    let searchTerm = $(".t4s-mini-search__input").val();

    let entry = {
      event: 'buscar_click_enter',
      user_id: window.user_id,
      category: 'click',
      option: searchTerm
    };

    dataLayer.push(entry);
  });

  //subscribe to click event from element with .t4s-frm-search__content > t4s-row
  $(document).on('click', '.t4s-frm-search__content > .t4s-row', function () {
    let searchTerm = $(".t4s-search-header__input").val();

    //search element child with class .t4s-widget__pr-title
    let product = $(this).find('.t4s-widget__pr-title').text();

    console.log("click", searchTerm);
    console.log("click", product);

    let entry = {
      event: 'buscar_producto_sugerido',
      user_id: window.user_id,
      category: 'producto sugerido',
      option: searchTerm,
      action: product
    };

    dataLayer.push(entry);
  });

  //subscribe to click event from element with .t4s-mini-search__content > t4s-row
  $(document).on('click', '.t4s-mini-search__content > .t4s-row', function () {
    let searchTerm = $(".t4s-mini-search__input").val();

    //search element child with class .t4s-widget__pr-title
    let product = $(this).find('.t4s-widget__pr-title').text();

    console.log("click", searchTerm);
    console.log("click", product);

    let entry = {
      event: 'buscar_producto_sugerido',
      user_id: window.user_id,
      category: 'producto sugerido',
      option: searchTerm,
      action: product
    };

    dataLayer.push(entry);
  });

  //click data-action-wishlist attribute
  $(document).on('click', '.t4s-pr-wishlist', function () {
    console.log("Add to wishlist");
    let parent = $(this).closest('[data-dl-object="item_view"]');
    let dl_object_id = parent.attr('data-dl-object-id');
    let dl_object_extra = parent.attr('data-dl-extra');

    console.log('Add to wishlist with id: ' + dl_object_id);
    console.log('Add to wishlist with extra: ' + dl_object_extra);

    analizeProduct(dl_object_id, "wishlist", "wishlist" , 'add_to_wishlist', dl_object_extra);
  });

  //Suscribe to click event from element with data-dl-object="promo"
  $(document).on('click', '[data-dl-object="promo"]', function () {
    let dl_object_id = $(this).attr('data-dl-object-id');

    let object = window.dl_objects.find(o => o.internal_id == dl_object_id);

    console.log("Promo", object);

    var promotionCreative = object.promotion_creative;

    if (isMobile && object.promotion_creative_mobile) {
      promotionCreative = object.promotion_creative_mobile;
    }

    let dataLayerEntry = {
      event: 'select_promotion',
      ecommerce: {
        user_id: window.user_id,
        items: [
          {
            promotion_id: object.promotion_id,
            promotion_name: object.promotion_name,
            creative_name: promotionCreative,
            creative_slot: 1,
            location_id: object.promotion_location_id,
            index: 1
          }
        ]
      }
    };

    if (object.product) {
      dataLayerEntry.ecommerce.items[0].item_id = object.product.item_id;
      dataLayerEntry.ecommerce.items[0].item_name = object.product.item_name;
      dataLayerEntry.ecommerce.items[0].item_brand = object.product.item_brand;
      dataLayerEntry.ecommerce.items[0].item_category = object.product.item_category;
      dataLayerEntry.ecommerce.items[0].item_category2 = object.product.item_category2;
      dataLayerEntry.ecommerce.items[0].item_category3 = object.product.item_category3;
      dataLayerEntry.ecommerce.items[0].item_category4 = object.product.item_category4;
      dataLayerEntry.ecommerce.items[0].item_category5 = object.product.item_category5;
      dataLayerEntry.ecommerce.items[0].item_variant = object.product.item_variant;
      dataLayerEntry.ecommerce.items[0].price = object.product.item_price;
    }

    //console.log("Promo", dataLayerEntry);
    writeDataLayer(dataLayerEntry);

  });

  $(document).on('click', '[data-dl-object="item"]', function () {
    let dl_object_id = $(this).attr('data-dl-object-id');
    let dl_object_extra = $(this).attr('data-dl-extra');

    let listname = $(this).attr('data-dl-list-name');
    let listid = $(this).attr('data-dl-list-id');

    if(!listid){
      listid = listname;
    }
    analizeProduct(dl_object_id, listname, listid, 'select_item', dl_object_extra);

  });



  $(window).scroll(function () {

    clearTimeout($.data(this, 'scrollTimer'));

    $.data(this, 'scrollTimer', setTimeout(function () {
      // do something
      // analizeElementsInViewport('[data-dl-object="promo"]');

      analizeItemInViewport2('[data-dl-object="item"]', 'view_item_list');

      analizeItemInWishlist('[data-dl-object="wishlist_item"]', 'view_wishlist');

    }, 250));
  });

  analizeElementsInViewport('[data-dl-object="promo"]');

  analizeItemInViewport2('[data-dl-object="item"]', 'view_item_list');

  analizeItemInWishlist('[data-dl-object="wishlist_item"]', 'view_wishlist');

  analizeItemDetail('[data-dl-object="item_view"]');

});




// Selecciona todos los botones para abrir modales
const botonesModal = document.querySelectorAll('.boton-modal');

// Agrega un evento click a cada botón
botonesModal.forEach(boton => {
  boton.addEventListener('click', () => {
    const modal = document.querySelector(boton.dataset.modal); // Encuentra el modal correspondiente al botón
    modal.classList.add('mostrar'); // Agrega la clase "mostrar" para mostrar el modal
  });
});

// Selecciona todos los botones para cerrar modales
const botonesCerrar = document.querySelectorAll('.modal-cerrar');

// Agrega un evento click a cada botón
botonesCerrar.forEach(boton => {
  boton.addEventListener('click', () => {
    const modal = boton.closest('.modal'); // Encuentra el modal más cercano al botón
    modal.classList.remove('mostrar'); // Quita la clase "mostrar" para ocultar el modal
  });
});

// Cierra el modal si se hace clic fuera del contenido
window.addEventListener('click', evento => {
  const modales = document.querySelectorAll('.modal');
  modales.forEach(modal => {
    if (evento.target === modal) {
      modal.classList.remove('mostrar');
    }
  });
});

// Cierra el modal si se presiona la tecla Esc
window.addEventListener('keydown', evento => {
  const modales = document.querySelectorAll('.modal');
  modales.forEach(modal => {
    if (evento.key === 'Escape') {
      modal.classList.remove('mostrar');
    }
  });
});

///CONTACTANOS

// Obtener referencia al botón y al bloque de ayuda
const showHelpButton = document.getElementById('showHelpButton');
const close = document.querySelector('.help__container--close');
const helpContainer = document.querySelector('.help__container');

// Función que se ejecutará cuando se haga clic en el botón
function toggleHelpContainer() {
  // Comprobar el estado actual del bloque de ayuda
  if (helpContainer.style.display === 'none') {
    // Si está oculto, mostrarlo
    helpContainer.style.display = 'block';
  } else {
    // Si está visible, ocultarlo
    helpContainer.style.display = 'none';
  }
}
// Agregar un evento de clic al botón que llame a la función
showHelpButton.addEventListener('click', toggleHelpContainer);
close.addEventListener('click', toggleHelpContainer);




const divs = document.querySelectorAll(".t4s-swatch__item ");
const descripciones = document.querySelectorAll(".custom-descripcion");
const compo = document.querySelectorAll(".custom-compo");
const cuidados = document.querySelectorAll(".custom-cuidados");




async function downloadImage(
  imageSrc,
  nameOfDownload = 'wallpaper-noel',
) {
  const response = await fetch(imageSrc);

  const blobImage = await response.blob();

  const href = URL.createObjectURL(blobImage);

  const anchorElement = document.createElement('a');
  anchorElement.href = href;
  anchorElement.download = nameOfDownload;

  document.body.appendChild(anchorElement);
  anchorElement.click();

  document.body.removeChild(anchorElement);
  window.URL.revokeObjectURL(href);
}


//FUNCTIIONS DATA LAYER

function writeDataLayer(entry) {
  //dataLayer.push (entry);
  if (entry.ecommerce) {
    if (entry.event === 'view_item_list') {
      if (entry.ecommerce.items) {
        console.log("-------------- DataLayer Entry --------------");
        console.log("dataLayer", entry);
        dataLayer.push(entry);
        console.log("-------------- DataLayer Entry --------------");
      }
    } else {
      console.log("-------------- DataLayer Entry --------------");
      console.log("dataLayer", entry);
      dataLayer.push(entry);
      console.log("-------------- DataLayer Entry --------------");
    }
  }
}

function analizeItemDetail(selector) {
  if ($(selector).isInViewport()) {

    let dl_object_id = $(selector).attr('data-dl-object-id');
    let dl_object_extra = $(selector).attr('data-dl-extra');

    let extra_object = JSON.parse(dl_object_extra);


    console.log('Detail item in viewport with id: ' + dl_object_id);

    if (selector === '[data-dl-object="item_view"]') {
      // let object = $(this).attr('data-product-options');
      let listname = $(selector).attr('data-dl-list-name');
      let listid = $(selector).attr('data-dl-list-id');

      if(!listid){
        listid = listname;
      }
      
      fetch('/products/' + dl_object_id + '.js')
        .then(response => response.json())
        .then(data => {

          let product = data;

          let itemEntry = {
            item_id: extra_object.referencia_color,
            item_name: product.title,
            affiliation: "Galax",
            coupon: "",
            discount: 0,
            index: 0,
            item_brand: product.vendor,
            item_category: extra_object.category,
            item_category2: extra_object.category2,
            item_category3: extra_object.category3,
            item_category4: extra_object.category4,
            item_category5: extra_object.category5,
            item_referencia_color: extra_object.referencia_color,
            item_list_id: listid,
            item_list_name: listname,
            item_variant: product.variants.length > 0 ? product.variants[0].name : "",
            price: product.variants.length > 0 ? product.variants[0].price / 100 : 0,
            currency: 'COP'
          };

          localStorage.setItem(`product${product.id}`, JSON.stringify(itemEntry));


          let dataLayerEntry = {
            event: 'view_item',
            ecommerce: {
              user_id: window.user_id,
              items: [itemEntry]
            }
          };

          //console.log("Item", dataLayerEntry);
          //writeDataLayer(dataLayerEntry);

        });
    }
  }
}

async function analizeItemInViewport2(selector, event) {
  let elements = $(selector).toArray();
  let items = [];

  for (let i = 0; i < elements.length; i++) {
    // if ($(elements[i]).isInViewport()) {
    let dl_object_id = $(elements[i]).attr('data-dl-object-id');

    if (!productsMap.has(dl_object_id)) {
      let dl_object_extra = $(elements[i]).attr('data-dl-extra');
      let extra_object = JSON.parse(dl_object_extra);

      if (selector === '[data-dl-object="item"]' || selector === '[data-dl-object="wishlist_item"]') {
        let listname = $(elements[i]).attr('data-dl-list-name');
        let listid = $(selector).attr('data-dl-list-id');

        if(!listid){
          listid = listname;
        }
        
        let product = await fetch('/products/' + dl_object_id + '.js');
        product = await product.json();

        let itemEntry = {
          item_id: extra_object.referencia_color,
          item_name: product.title,
          affiliation: "Galax",
          coupon: "",
          discount: 0,
          index: window.dl_objects_index++,
          item_brand: product.vendor,
          item_category: extra_object.category,
          item_category2: extra_object.category2,
          item_category3: extra_object.category3,
          item_category4: extra_object.category4,
          item_category5: extra_object.category5,
          item_list_id: listid,
          item_list_name: listname,
          item_variant: product.variants.length > 0 ? product.variants[0].name : "",
          price: product.variants.length > 0 ? product.variants[0].price / 100 : 0,
          currency: 'COP'
        };

        items.push(itemEntry);
        productsMap.set(dl_object_id, itemEntry);
      }
    }
    // }
  }

  if (items.length > 0) {
    let dataLayerEntry = {
      event: event,
      ecommerce: {
        user_id: window.user_id,
        items: items
      }
    };

    writeDataLayer(dataLayerEntry);
  }

}

async function analizeItemInWishlist(selector, event) {
  let elements = $(selector).toArray();
  let items = [];

  for (let i = 0; i < elements.length; i++) {
    //check if element has parant with class grid-wishlist
    if ($(elements[i]).closest('.grid-wishlist').length > 0) {


      // if ($(elements[i]).isInViewport()) {

      let dl_object_id = $(elements[i]).attr('data-dl-object-id');

      if (!productsMap.has(dl_object_id)) {
        let dl_object_extra = $(elements[i]).attr('data-dl-extra');
        let extra_object = JSON.parse(dl_object_extra);

        if (selector === '[data-dl-object="item"]' || selector === '[data-dl-object="wishlist_item"]') {
          let listname = $(elements[i]).attr('data-dl-list-name');
          let listid = $(selector).attr('data-dl-list-id');

          if(!listid){
            listid = listname;
          }
          let product = await fetch('/products/' + dl_object_id + '.js');
          product = await product.json();

          let itemEntry = {
            item_id: extra_object.referencia_color,
            item_name: product.title,
            affiliation: "Galax",
            coupon: "",
            discount: 0,
            index: window.dl_objects_index++,
            item_brand: product.vendor,
            item_category: extra_object.category,
            item_category2: extra_object.category2,
            item_category3: extra_object.category3,
            item_category4: extra_object.category4,
            item_category5: extra_object.category5,
            item_list_id: listid,
            item_list_name: listname,
            item_variant: product.variants.length > 0 ? product.variants[0].name : "",
            price: product.variants.length > 0 ? product.variants[0].price / 100 : 0,
            currency: 'COP'
          };

          items.push(itemEntry);
          productsMap.set(dl_object_id, itemEntry);
        }
      }
    }
  }

  if (items.length > 0) {
    let dataLayerEntry = {
      event: event,
      ecommerce: {
        user_id: window.user_id,
        items: items
      }
    };

    writeDataLayer(dataLayerEntry);
  }

}

function analizeItemInViewport(selector) {
  let products = [];
  console.log("Analizing items in viewport");
  $(selector).each(function (index) {
    // console.log("Element", index);
    //analize if element is in viewport with vanilla js

    if ($(this).isInViewport()) {

      let dl_object_id = $(this).attr('data-dl-object-id');
      let dl_object_extra = $(this).attr('data-dl-extra');
      let extra_object = JSON.parse(dl_object_extra);

      if (selector === '[data-dl-object="item"]') {
        // let object = $(this).attr('data-product-options');
        let listname = $(this).attr('data-dl-list-name');
        fetch('/products/' + dl_object_id + '.js')
          .then(response => response.json())
          .then(data => {
            // console.log("from fetch");
            // console.log(data);
            let product = data;

            let itemEntry = {
              item_id: extra_object.referencia_color,
              item_name: product.title,
              affiliation: "Galax",
              coupon: "",
              discount: 0,
              index: window.dl_objects_index++,
              item_brand: product.vendor,
              item_category: extra_object.category,
              item_category2: extra_object.category2,
              item_category3: extra_object.category3,
              item_category4: extra_object.category4,
              item_category5: extra_object.category5,
              item_list_name: listname,
              item_variant: product.variants.length > 0 ? product.variants[0].name : "",
              price: product.variants.length > 0 ? product.variants[0].price : 0,
              currency: 'COP'
            };

            // products.push(itemEntry);
            let dataLayerEntry = {
              event: 'view_item_list',
              ecommerce: {
                user_id: window.user_id,
                items: [itemEntry]
              }
            };

            writeDataLayer(dataLayerEntry);

          });
      }
    }
  });

  console.log("Products length", products.length);

  let dataLayerEntry = {
    event: 'view_item_list',
    ecommerce: {
      user_id: window.user_id,
      items: products
    }
  };

  writeDataLayer(dataLayerEntry);

}

function analizeElementsInViewport(selector) {
  console.log("Analizing elements in viewport");
  console.log(selector);

  $(selector).each(function (index) {
    // console.log("Element", index);
    // if ($(this).isInViewport()) {
    let dl_object_id = $(this).attr('data-dl-object-id');

    console.log('Element in viewport with id: ' + dl_object_id);

    let object = window.dl_objects.find(o => o.internal_id == dl_object_id);

    console.log("Promo", object);

    var promotionCreative = object.promotion_creative;

    if (isMobile && object.promotion_creative_mobile) {
      promotionCreative = object.promotion_creative_mobile;
    }

    let dataLayerEntry = {
      event: 'view_promotion',
      ecommerce: {
        user_id: window.user_id,
        items: [
          {
            promotion_id: object.promotion_id,
            promotion_name: object.promotion_name,
            creative_name: promotionCreative,
            creative_slot: 1,
            location_id: object.promotion_location_id,
            index: 1
          }
        ]
      }
    };

    if (object.product) {
      dataLayerEntry.ecommerce.items[0].item_id = object.product.item_id;
      dataLayerEntry.ecommerce.items[0].item_name = object.product.item_name;
      dataLayerEntry.ecommerce.items[0].item_brand = object.product.item_brand;
      dataLayerEntry.ecommerce.items[0].item_category = object.product.item_category;
      dataLayerEntry.ecommerce.items[0].item_category2 = object.product.item_category2;
      dataLayerEntry.ecommerce.items[0].item_category3 = object.product.item_category3;
      dataLayerEntry.ecommerce.items[0].item_category4 = object.product.item_category4;
      dataLayerEntry.ecommerce.items[0].item_category5 = object.product.item_category5;
      dataLayerEntry.ecommerce.items[0].item_variant = object.product.item_variant;
      dataLayerEntry.ecommerce.items[0].price = object.product.item_price;
    }

    //console.log("Promo", dataLayerEntry);
    writeDataLayer(dataLayerEntry);
    // }
  });
}

function analizeProduct(dl_object_id, listname, listid, event, dl_object_extra) {
  console.log("dl_object_extra", dl_object_extra);

  let extra_object = JSON.parse(dl_object_extra);

  console.log("extra_object", extra_object);

  fetch('/products/' + dl_object_id + '.js')
    .then(response => response.json())
    .then(data => {
      console.log("from fetch");
      console.log(data);
      let product = data;

      let itemEntry = {
        item_id: extra_object.referencia_color,
        item_name: product.title,
        affiliation: "Galax",
        coupon: "",
        discount: 0,
        index: 0,
        item_brand: product.vendor,
        item_category: extra_object.category,
        item_category2: extra_object.category2,
        item_category3: extra_object.category3,
        //item_category4: product.variants.length > 0 ? product.variants[0].option1 : "",
        item_category4: extra_object.category4,
        item_category5: extra_object.category5,
        item_list_id: listid,
        item_list_name: listname,
        item_variant: product.variants.length > 0 ? product.variants[0].name : "",
        price: product.variants.length > 0 ? product.variants[0].price / 100 : 0,
        currency: 'COP'
      };

      localStorage.setItem(`product${product.id}`, JSON.stringify(itemEntry));

      let dataLayerEntry = {
        event: event,
        ecommerce: {
          user_id: window.user_id,
          items: [itemEntry]
        }
      };

      //onsole.log("Item", dataLayerEntry);
      writeDataLayer(dataLayerEntry);

    });
}

//// BARRA DE NAVEGACIÓN ////
// DESKTOP //
for (let i = 0; i < arrayElements.length; i++) {

  // Guardo cada sub-link dentro de su respectivo link
  arrayElements[i].items = arrayNavItems[i]

  // Creo mi objeto para todos los links con sus respectivos sub-links
  elements['element' + i] = arrayElements[i];

  // Texto del link
  let elementName = arrayElements[i].element_li_name;

  // Cambio los texto de mayuscula sostenida a solo la primera letra en mayuscula
  arrayElements[i].element_li_name = changeCapitalizationOrGeneralFormat(elementName);
}

// Busco cada ID guardado para encontrar el valor del texto
for (let i = 0; i < arrayNavSubitems.length; i++) {

  // Obtener el texto dentro del HTML que apunta el ID
  const text = getTextFromHtmlDivChild(arrayNavSubitems[i].subitem_nav_id, 0)

  // Guardo el dato
  arrayNavSubitems[i].subitem_nav_name = text;
}

// Buscamos donde pertencese cada sub-tipo
for (let key in elements) {

  // Elemento padre
  const parentId = elements[key].element_div_id;
  let count = 0;
  nav_subitems = {};

  // Reviso de mi arreglo que elementos hijos pertenecen al elemento padre
  for (let i = 0; i < arrayNavSubitems.length; i++) {

    // Elemento hijo
    let childId = arrayNavSubitems[i].subitem_nav_id;

    // Busco si elemento hijo esta dentro de elemento padre
    let isChildInsideParent = checkParentElement(childId, parentId);

    // Si el elemento hijo está dentro del elemento padre
    if (isChildInsideParent) {

      // Creo mi objeto
      nav_subitems['items' + count] = arrayNavSubitems[i];

      // Sumo 1 a la cuenta
      count++
    }
  }

  // Guardo el objeto en su grupo correspondiente
  elements[key].subitems = nav_subitems;
};

// MOBILE //
for (let key in elements_mobile) {

  // Texto del link
  let name = elements_mobile[key].item_nav_name;

  // Cambio los texto de mayuscula sostenida a solo la primera letra en mayuscula
  elements_mobile[key].item_nav_name = changeCapitalizationOrGeneralFormat(name)

  let items = elements_mobile[key].items;
  if (items !== "") {

    // Iterar sobre cada item del objeto
    for (let key2 in items) {
      if (items[key2].subitems !== "") {
        let subitems = items[key2].subitems;

        // Iterar sobre cada subitem del item
        for (let key3 in subitems) {

          // Obtener el texto dentro del HTML que apunta el ID
          subitems[key3].subitem_nav_name = getTextFromHtmlDivChild(subitems[key3].subitem_nav_id, 1)
        }
      }
    }
  }
}

// Enviar información de la barra de navegación
var count = 0;
function sendData(itemId, num, type, category) {
  console.log("clic itemId", itemId);
  // Data layer
  let data = {
    event: "megamenu_categoria",
    user_id: window.user_id,
    categoria_menu: "",
    option: "",
    action: ""
  }

  let sendDataInf = false; // Enviar información

  // Si es Desktop
  if (type === 0) {

    // Valido que no se esten dando click dentro id="content_${itemId}" que activen el click de "Ver Todo"
    if (num !== 3) {

      // Valido que no se reenvie la información de "Ver Todo" al hacer click dentro de un sub-link del elemento
      if (count === undefined || count === 0) {

        for (const key in elements) {
          const element = elements[key];
          if (category !== 2) {
            if (element.element_li_id === itemId) {

              data.categoria_menu = elements[key].element_li_name;
              data.option = elements[key].element_type;
              data.action = "Ver Todo";

            } else if (element.items) {
              for (const itemKey in element.items) {
                const item = element.items[itemKey];
                if (item.item_nav_id === itemId) {

                  data.categoria_menu = elements[key].element_li_name;
                  data.option = elements[key].items[itemKey].item_nav_type;
                  data.action = elements[key].items[itemKey].item_nav_name;

                }
              }
            }
          } else {
            if (element.subitems !== "") {
              for (const subitemKey in element.subitems) {
                const item = element.subitems[subitemKey];
                if (item.subitem_nav_id === itemId) {

                  data.categoria_menu = elements[key].element_li_name;
                  data.option = elements[key].subitems[subitemKey].subitem_nav_type;
                  data.action = elements[key].subitems[subitemKey].subitem_nav_name;
                }
              }
            }
          }
        }
        sendDataInf = true;
      } else {
        count = 0;
      }
      if (num === 1) {
        //count++;
      }
    } else {
      //count++;
    }
    // Si es Mobile
  } else {
    if (num !== 0) {

      // Iterar sobre cada elemento del objeto
      for (let key in elements_mobile) {
        let elementsMobile = elements_mobile[key]

        // Si el id conincide con el element_mobile id
        if (elementsMobile.item_nav_id === itemId) {

          data.categoria_menu = elementsMobile.item_nav_name;
          data.option = elementsMobile.item_nav_type;
          data.action = "Ver Todo";

          break;
        }

        // Buscamos si el id conincide con uno de sus items, si items no esta vacio
        if (elementsMobile.items !== "") {

          // Items
          let items = elementsMobile.items;

          // Iterar sobre cada item del objeto
          for (let key2 in items) {
            let item = items[key2];

            // Si el id del item coincide con el id
            if (item.item_nav_id === itemId) {

              data.categoria_menu = elementsMobile.item_nav_name;
              data.option = item.item_nav_type;
              data.action = item.item_nav_name;

              break;
            }

            // Buscamos si el id conincide con uno de sus subitems, si subitems no esta vacio
            if (item.subitems !== "") {

              // Subitems
              let subitems = item.subitems;

              // Iterar sobre cada subitem del item
              for (let key3 in subitems) {
                let subitem = subitems[key3];

                if (subitem.subitem_nav_id === itemId) {
                  data.categoria_menu = elementsMobile.item_nav_name;
                  data.option = subitem.subitem_nav_type;
                  data.action = subitem.subitem_nav_name;

                  break;
                }
              }
            }
          }
        }
      }
      sendDataInf = true;
    }
  }
  console.log("data", data);
  if (sendDataInf === true) {
    console.log(data);
    dataLayer.push(data);
  }
}

// Validar si un elemento hijo existe dentro de un elemento padre
function checkParentElement(childId, parentId) {
  // Obtener el elemento hijo
  const childElement = document.getElementById(childId);

  // Verificar si el elemento hijo existe
  if (childElement) {
    // Obtener el ancestro más cercano con el ID especificado
    const parentElement = childElement.closest(`#${parentId}`);

    // Verificar si se encontró el ancestro con el ID especificado
    if (parentElement) {
      // Devolver true si se encontró el ancestro
      return true;
    }
  }

  // Devolver false si el elemento hijo o el ancestro no se encontraron
  return false;
}

// Obtener texto de un div por medio de su ID
function getTextFromHtmlDivChild(id, type) {

  let text = ""; // Texto de retorno

  if (type === 0) {
    // Obtener el elemento div por su id
    const divElement = document.getElementById(id);

    // Obtener el elemento <p> dentro del div
    const pElement = divElement.querySelector('p');

    // Obtener el texto dentro del elemento <p>
    text = pElement.textContent.trim();

  } else if (type === 1) {

    // Obtener el elemento li por su id
    const liElement = document.getElementById(id);

    // Obtener el texto dentro del elemento li
    text = liElement.textContent.trim();
  }

  return text;
}

// Retorna un texto en mayuscula sostenida a un texto con formato general (MAYÚSCULA > Mayúscula)
function changeCapitalizationOrGeneralFormat(text) {
  // Cambio los texto de mayuscula sostenida a solo la primera letra en mayuscula
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
}

function sendDataSimple(typeEvent, category, option) {
  let data = {
    event: typeEvent,
    user_id: window.user_id,
    category: changeCapitalizationOrGeneralFormat(category),
    option: option,
  }

  console.log(data)
  dataLayer.push(data);
}

// Obtener el input por su ID
// const input = document.getElementById('miInput');

// // Agregar un evento de teclado al input
// input.addEventListener('keydown', function(event) {
//   // Verificar si la tecla presionada es "Enter"
//   if (event.key === 'Enter') {
//       // Ejecutar tu código aquí
//       console.log('Se presionó la tecla Enter');
//   }
// });